<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import BuhotextCampaignForm from './BuhotextCampaignForm.vue';

const props = defineProps({
  campaign: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();

const handleSubmit = async formData => {
  try {
    if (props.campaign) {
      await store.dispatch('buhotextCampaigns/update', {
        id: props.campaign.id,
        ...formData,
      });
      useAlert(t('BUHOTEXT_CAMPAIGNS.EDIT.API.SUCCESS_MESSAGE'));
    } else {
      await store.dispatch('buhotextCampaigns/create', formData);
      useAlert(t('BUHOTEXT_CAMPAIGNS.CREATE.API.SUCCESS_MESSAGE'));
    }
    emit('close');
  } catch (error) {
    const messageKey = props.campaign
      ? 'BUHOTEXT_CAMPAIGNS.EDIT.API.ERROR_MESSAGE'
      : 'BUHOTEXT_CAMPAIGNS.CREATE.API.ERROR_MESSAGE';
    useAlert(t(messageKey), 'error');
  }
};

const handleClose = () => emit('close');
</script>

<template>
  <div
    class="w-[30rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-n-alpha-3 backdrop-blur-[100px] rounded-xl border border-n-weak shadow-md max-h-[80vh] overflow-y-auto"
  >
    <div class="p-6 flex flex-col gap-6">
      <h3 class="text-base font-medium text-n-slate-12 flex-shrink-0">
        {{
          campaign
            ? t('BUHOTEXT_CAMPAIGNS.EDIT.TITLE')
            : t('BUHOTEXT_CAMPAIGNS.CREATE.TITLE')
        }}
      </h3>
      <BuhotextCampaignForm
        :campaign="campaign"
        @submit="handleSubmit"
        @cancel="handleClose"
      />
    </div>
  </div>
</template>
